import { Controller } from '@hotwired/stimulus'
import { isAfter, isSameDay } from 'date-fns'

export default class extends Controller {
  static targets = ['processCheckbox', 'processedCloseButton', 'processedOpenButton']

  connect() {
    this.toggleProcessedButtonDisabled();
  }

  checkAll() {
    for (const el of this.processCheckboxTargets) {
      if(el.disabled) {
        continue;
      }

      el.checked       = true;
      el.indeterminate = false;
    }
    this.toggleProcessedButtonDisabled();
  }

  uncheckAll() {
    for (const el of this.processCheckboxTargets) {
      if(el.disabled) {
        continue;
      }

      el.checked       = false;
      el.indeterminate = false;
    }
    this.toggleProcessedButtonDisabled();
  }

  toggleProcessedButtonDisabled() {
    const checkeds = this.processCheckboxTargets.filter(checkbox => checkbox.checked);

    // 不開講ボタンの活性状態
    this.processedCloseButtonTarget.disabled = checkeds.length === 0;
    // 開講ボタンの活性状態
    this.processedOpenButtonTarget.disabled = checkeds.length === 0 || checkeds.some(checkbox => {
      const applicationEndDate = new Date(checkbox.dataset.applicationEndDate);
      const today = new Date();

      return isAfter(applicationEndDate, today) || isSameDay(applicationEndDate, today);
    });
  }
}
